import { IsAlphanumeric, IsNumber, Max, Min } from 'class-validator';
import { AllergenDto } from './allergen.dto';
import { BaseDto } from './base.dto';
import { BrandDto } from './brand.dto';
import { BundleCombinationDto } from './bundleCombination.dto';
import { BundleMenuCategoryDto } from './bundleMenuCategory.dto';
import { DietDto } from './diet.dto';
import { MerchantDto } from './merchant.dto';
import { ProductCategoryDto } from './productCategory.dto';
import { ProductHoursDto } from './productHours.dto';
import { ProductMenuModifierDto } from './productMenuModifier.dto';
import { ProductModifierGroupDto } from './productModifierGroup.dto';
import { ProductNutritionDto } from './productNutrition.dto';
import { ProductOutOfStockDto } from './productOutOfStock.dto';
import { RecipeDto } from './recipe.dto';
import { RetailPriceDto } from './retailPrice.dto';
import { StockDto } from './stock.dto';
import { VATRateDto } from './vat-rate.dto';
import { IProductCostings } from '../interface/product/product-costings.interface';

export class ProductDto extends BaseDto {
  name: string;
  code: string;
  photoURL: string;
  photoURLBase64?: string;
  productCategoryId: number;
  merchantId?: number;
  calorieCount: number;
  preparationTime: number;
  price: number;
  vatRate: VATRateDto;
  startDate?: Date;
  endDate?: Date;
  description: string;
  shortDescription: string;
  vatRateId: number;

  @IsNumber()
  @Min(0)
  @Max(2147483647)
  pointsGiven?: number;

  @IsNumber()
  @Min(0)
  @Max(2147483647)
  pointsRequired?: number;

  productCategory: ProductCategoryDto;
  productCategoryLev1?: ProductCategoryDto;
  productCategoryLev2?: ProductCategoryDto;
  printName?: string;
  receiptName?: string;
  diets?: DietDto[];
  allergens?: AllergenDto[];
  nutrition?: ProductNutritionDto;
  nutritionFact?: ProductNutritionDto;
  stock: StockDto[];
  productModifierGroups?: ProductModifierGroupDto[];
  minPrice?: number;
  merchant: MerchantDto;
  active?: boolean;
  online?: boolean;
  sharedSourceName?: string;
  brandId?: number;
  brand?: BrandDto;
  referenceNumber?: number;
  ABV: number;
  remaining: number;
  color: string;
  region: string;
  type: string;
  tag: string;
  hasGroupModifier: boolean;
  isDiscountable: boolean;
  isPopular?: boolean;
  isBundle?: boolean;
  bundleCombinations?: BundleCombinationDto[];
  bundleProducts?: ProductMenuModifierDto[];
  bundleMenuCategories?: BundleMenuCategoryDto[];
  bundleChecked?: boolean;
  isMainCourse?: boolean;
  productHours?: ProductHoursDto[];
  productsOutOfStock?: ProductOutOfStockDto[];
  retailPrices?: RetailPriceDto[];
  currentRetailPrices?: RetailPriceDto[];
  recipes?: RecipeDto[];
  isLoyalty?: boolean;
  isOpenPrice: boolean;
  cartProductStockSelected?: number;
  isAgeVerification: boolean;
  
  @IsAlphanumeric()
  barCode: string;

  costings?: IProductCostings;

  drsEnabled?: boolean;
  drsValue?: number;

  colorCode?: string;
}
